import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { FaSignal } from 'react-icons/fa';
import styled from 'styled-components';
import NavbarComponent from '../../components/NavbarComponent';
import FooterComponent from '../../components/FooterComponent';

// Styled components
const SkillLevelCard = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ selected }) => (selected ? '#2ECC71' : '#232830')};
  color: ${({ selected }) => (selected ? '#fff' : '#ddd')};
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  border: 1px solid ${({ selected }) => (selected ? '#2ECC71' : 'transparent')};
  &:hover {
    transform: scale(1.03);
  }
`;

const SignalWrapper = styled.div`
  font-size: 24px;
  margin-right: 15px;
  color: ${({ selected }) => (selected ? '#fff' : '#4CAF50')};
`;

const SkillTitle = styled.span`
  flex: 1;
  font-size: 18px;
  font-weight: bold;
`;

const FindCourseSkillLevel = () => {
  const [selectedSkill, setSelectedSkill] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const db = getFirestore();
  const auth = getAuth();

  const course = location.state?.selectedCourse; // Get selected course from navigation state
  const courseName = course?.coursename || 'this topic';

  const skillLevels = [
    { id: 1, name: `I'm new to ${courseName}` },
    { id: 2, name: `I know some common terms in ${courseName}` },
    { id: 3, name: `I understand basic concepts of ${courseName}` },
    { id: 4, name: `I can analyze & interpret ${courseName} data` },
    { id: 5, name: `I am advanced in ${courseName}` }
  ];

  const handleSkillSelection = (level) => {
    setSelectedSkill(level);
  };

  const handleContinue = async () => {
    if (!selectedSkill || !course) {
      alert('Please select a skill level before continuing.');
      return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
      alert('User not found. Please log in again.');
      return;
    }

    try {
      await addDoc(collection(db, 'userskilllevel'), {
        userid: currentUser.uid,
        courseid: course.courseid,
        coursename: course.coursename,
        skillLevel: selectedSkill.name,
        date: serverTimestamp(),
      });

      console.log('Skill level saved successfully!');
      navigate('/find-my-skill-level-step'); // Replace with the actual next step in onboarding
    } catch (error) {
      console.error('Error saving skill level:', error);
      alert('Failed to save skill level. Please try again.');
    }
  };

  return (
    <>
      <NavbarComponent />

      <Container className="text-center my-5" style={{ backgroundColor: '#1A1A1A', color: '#fff', padding: '20px', borderRadius: '10px' }}>
        {/* Course Selection Title */}
        <h3 style={{ fontSize: '22px', fontWeight: 'bold', color: '#2ECC71', marginBottom: '20px' }}>
          {course ? `How much do you know about ${courseName}?` : 'Choose your skill level'}
        </h3>

        {/* Skill Level Options */}
        {skillLevels.map((level, index) => (
          <SkillLevelCard key={level.id} selected={selectedSkill?.id === level.id} onClick={() => handleSkillSelection(level)}>
            <SignalWrapper selected={selectedSkill?.id === level.id}>
              {Array(index + 1).fill(<FaSignal />)}
            </SignalWrapper>
            <SkillTitle>{level.name}</SkillTitle>
          </SkillLevelCard>
        ))}

        {/* Continue Button */}
        <Button
          onClick={handleContinue}
          style={{
            backgroundColor: selectedSkill ? '#FF7C24' : '#444',
            borderColor: selectedSkill ? '#FF7C24' : '#444',
            fontSize: '18px',
            fontWeight: 'bold',
            borderRadius: '10px',
            padding: '12px 30px',
            marginTop: '20px',
            cursor: selectedSkill ? 'pointer' : 'not-allowed',
          }}
          disabled={!selectedSkill}
        >
          Continue
        </Button>
      </Container>

      <FooterComponent />
    </>
  );
};

export default FindCourseSkillLevel;
